import * as React from "react";

function BoldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M303.8 241.7c2.084-1.838 4.41-3.307 6.385-5.303 22.72-22.91 35.03-53.31 34.72-85.59C344.3 85.31 290.4 32 224.9 32H24C10.75 32 0 42.75 0 56s10.75 24 24 24h24v352H24c-13.25 0-24 10.8-24 24s10.75 24 24 24h216c70.59 0 128-57.41 128-128 0-47.2-26.9-88.1-64.2-110.3zM224.9 80c39.31 0 71.59 32 72 71.31.188 19.34-7.219 37.56-20.84 51.34C262.5 216.4 244.3 224 224.9 224H96V80h128.9zM240 432H96V272h144c44.13 0 80 35.88 80 80.01S284.1 432 240 432z"
  }));
}

const ForwardRef = React.forwardRef(BoldIcon);
export default ForwardRef;